module.exports = __webpack_public_path__ + "static/media/facebook.3d65287b.svg";